module.exports = __webpack_public_path__ + "static/media/tstm-globalsat.cc699344.webp";